import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import { AppState } from "shared/data/reducers";
import { formatMoney } from "shared/lib/functions";
import { priceFormatter } from "shared/lib/priceFormatter";

import Alert from "@components/UI/Alert";
import Modal from "@components/UI/Modal";
import PrimaryButton from "@components/UI/PrimaryButton";

type LowCostSearchSelectFlightsModalProps = {
  isActive: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedDays: { from: Date; to: Date };
  totalPrice: { totalPrice: number; currency: string };
};

const formatPrice = (price: number, currency: string) => {
  const currentFormatOption = priceFormatter({ currency });
  const money = formatMoney(
    price,
    currentFormatOption.decimalScale,
    currentFormatOption.decimalSeparator,
    currentFormatOption.thousandSeparator
  );

  return `${money} ${currency}`;
};

export function LowCostSearchSelectFlightsModal({
  isActive,
  onClose,
  onConfirm,
  selectedDays,
  totalPrice,
}: LowCostSearchSelectFlightsModalProps) {
  const { currentLanguage } = useSelector(
    (state: AppState) => state.requestorConfig
  );

  const shouldRenderAlert = () => !selectedDays.from || !selectedDays.to;
  const renderAlert = () => (
    <Alert type="warning">
      <FormattedMessage id="LowCostSearch.errorSelectDates" />
    </Alert>
  );

  const currencySymbol =
    totalPrice.currency === "CZK" && currentLanguage === "cs"
      ? "Kč"
      : totalPrice.currency;

  const renderFlightsInfo = () => (
    <div>
      <h3 className="select-low-cost-flights-modal__title">
        <FormattedMessage id="LowCostSearch.totalPrice" />{" "}
        {formatPrice(totalPrice.totalPrice, currencySymbol)}
      </h3>
      <p className="select-low-cost-flights-modal__text">
        <FormattedMessage id="LowCostSearch.totalPriceDisclaimer" />
      </p>
      <div className="select-low-cost-flights-modal__buttons">
        <PrimaryButton onClick={() => onConfirm()}>
          <FormattedMessage id="LowCostSearch.continue" />
        </PrimaryButton>
      </div>
    </div>
  );
  return (
    <Modal isActive={isActive} onClose={onClose}>
      <div className="select-low-cost-flights-modal">
        {shouldRenderAlert() && renderAlert()}
        {!shouldRenderAlert() && renderFlightsInfo()}
      </div>
    </Modal>
  );
}

export default LowCostSearchSelectFlightsModal;
